import {useContext, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import useGetApiData from './useGetApiData';
import auth from '../../../../lib/auth';
import {NetworkContext} from '../../lib/context';

const useGenerateReportController = () => {

    const {rosterId, revisionId} = useParams();
    const networkStore = useContext(NetworkContext);
    const [mapsLoading, setMapsLoading] = useState(true);
    const [tablesLoading, setTablesLoading] = useState(true);
    const clientName = auth.principal?.orgs[0]?.name || 'Milliman';

    useEffect(() => {
        const style = document.createElement('style');
        const leftFooter = `${clientName} – Network Analysis`;
        const rightFooter = `${new Date().toLocaleString('default', {month: 'long'})} ${new Date().getFullYear()}`;
        style.innerHTML = `
            @media print {
                @page {
                    @bottom-left {
                        content: "${leftFooter}";
                    }
                    @bottom-right {
                        content: "${rightFooter}";
                    }
                }
                @page table-of-contents {
                    @top-left {
                        content: "MILLIMAN REPORT";
                        font-size: 10px;
                        padding: 0;
                        margin: 0;
                        vertical-align: middle;
                    }
                    @bottom-right {
                        content: "";
                        border: none;
                    }
                    @bottom-left {
                        content: "";
                        border: none;
                    }
                }
                @page start-cover {
                    @bottom-right {
                        content: "";
                        border: none;
                    }
                    @bottom-left {
                        content: "";
                        border: none;
                    }
                }
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };

    }, [clientName]);
    
    useEffect(() => {
        // Event-based loading state (replaced DOM polling for better performance)
        const handleAllMapsLoaded = () => {
            setMapsLoading(false);
        };

        window.addEventListener('allMapsLoaded', handleAllMapsLoaded);

        return () => {
            window.removeEventListener('allMapsLoaded', handleAllMapsLoaded);
        };
    }, []);

    const {
        data: {
            specialtyGroupings,
            maxTimeDistData,
            providerAvgTimeDistData,
            facilityAvgTimeDistData,
            allSpecialtyCountyData
        }
    } = useGetApiData();

    useEffect(() => {
        const anyDataLoading = specialtyGroupings.loading ||
                               maxTimeDistData.loading ||
                               providerAvgTimeDistData.loading ||
                               facilityAvgTimeDistData.loading ||
                               allSpecialtyCountyData.loading ||
                               networkStore.reportProviderGeoJsonLoading;

        setTablesLoading(anyDataLoading);
    }, [specialtyGroupings.loading, maxTimeDistData.loading, providerAvgTimeDistData.loading, facilityAvgTimeDistData.loading, allSpecialtyCountyData.loading, networkStore.reportProviderGeoJsonLoading]);

    const printReport = () => {
        print();
    };

    return {
        data: {
            rosterId,
            revisionId,
            clientName,
            mapsLoading,
            tablesLoading,
            specialtyGroupings,
            maxTimeDistData,
            providerAvgTimeDistData,
            facilityAvgTimeDistData,
            allSpecialtyCountyData
        },
        methods: {
            printReport
        }
    };
};

export type IGenerateReportController = ReturnType<typeof useGenerateReportController>;

export default useGenerateReportController;
